import {
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useCart } from "@/lib/cart";

export function CartDrawer() {
  const { setIsOpen } = useCart();

  return (
    <SheetContent className="sm:max-w-md">
      <SheetHeader>
        <SheetTitle>Checkout</SheetTitle>
      </SheetHeader>

      <div className="mt-6 space-y-4 text-sm leading-relaxed text-gray-700">
        <p>
          Thanks for getting this far. Our crypto payment system is in the process of being built.
          If you would like to purchage a bottle right away, reach out to me at{" "}
          <a
            className="font-medium text-blue-700 hover:underline"
            href="mailto:support@vermontforest.com"
          >
            support@vermontforest.com
          </a>{" "}
          to use Zelle or Venmo. Thank you.
        </p>

        <div className="pt-2 space-y-2">
          <Button
            className="w-full"
            onClick={() => {
              window.location.href = "mailto:support@vermontforest.com";
            }}
          >
            Email support@vermontforest.com
          </Button>
          <Button className="w-full" variant="outline" onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </div>
      </div>
    </SheetContent>
  );
}
